export const OcaenFreightRateRequestColumns = [
    "SNo",
    "Destination",
    "Country",
    "Liner",
    "BasicPrice",
    "OtherCharge"
]